import ReleaseImageCardList from './ReleaseImageCardList';

export default ReleaseImageCardList;
